/*-----------------------------------------------------------------
- landing
-----------------------------------------------------------------*/
export default {
    title: '',

    subtitle: {
        title: '',
    },
};

